import axios from "axios";

export const authapi =
  "https://script.google.com/macros/s/AKfycbwzE_qiEgGHBtD1HWJBxGncHAsSTL6keXr51DOc6D0dv_WG6mpLcbWzAgf8bHE9rwRg/exec";
export const dataapi =
  "https://script.google.com/macros/s/AKfycbw2SEtjEGER853ih5TSPwnN7Kr21U22howGSHPdis4tnH4LiHxd7LQ8Pg_5_MGhFR_g/exec";

export const adminapi =
  "https://script.google.com/macros/s/AKfycbz_slUKUfXs0z3yg3BVREK-J9AEnyyrCSYVF0_Nh_8fVzN4lUBDItYeq73N7Bpzi84W/exec";
